import { SideStatistics } from '@ahc-digital/component-library';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { CreateSideStatisticsModel } from './C51SideStatistics.service';
import { C51SideStatisticsProps } from './C51SideStatistics.types';
import { SwitchToPreviewMessage } from 'src/shared/SwitchToPreviewMessage';
import { translationClasses } from 'src/shared/TranslationClasses';

export default function C51SideStatistics(props?: C51SideStatisticsProps) {
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing ?? false;

  if (!props?.rendering?.dataSource) {
    return <PromptForMissingDatasource rendering={props?.rendering} />;
  }

  const model = CreateSideStatisticsModel(props);

  if (isEditing) {
    return (
      <SwitchToPreviewMessage componentName={props?.rendering.componentName}>
        <SideStatistics
          className={translationClasses(props?.params)}
          id={props?.params?.AnchorLinkTargetName}
          {...model}
        />
      </SwitchToPreviewMessage>
    );
  }

  return (
    <SideStatistics
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      {...model}
    />
  );
}
